import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { useQueryParams } from '@hooks/queryParams';
import { SchedulesConflictsProps, SchedulesConflictsRespSuccess } from './types';

export const useGetSchedulesConflicts = ({
  startsAt,
  endsAt,
  date,
  scheduleId,
  taskType,
  enabled = true,
}: SchedulesConflictsProps) => {
  const { parseParams } = useQueryParams();

  const queryParams = parseParams({ startsAt, endsAt, date, scheduleId, taskType });

  const { data, error, isPending } = useQuery<SchedulesConflictsRespSuccess, ApiError>({
    queryKey: [...queryKeys.schedules.conflicts, queryParams],
    queryFn: () => queryFetch({ url: `schedules_conflicts${queryParams}` }),
    placeholderData: (previousData) => previousData as SchedulesConflictsRespSuccess,
    enabled: Boolean((startsAt && endsAt) || date) && enabled,
  });

  return {
    data,
    error,
    isLoading: isPending && Boolean((startsAt && endsAt) || date) && enabled,
  };
};
